<template>
	<div class="bcContainer">
		<v-layout class="showBCButton" :style="!$vuetify.breakpoint.smAndDown ? 'top: 132px; right: 48px;' : 'top: 112px; right: 10px;' ">
		<v-btn icon	@click="setBuildingCardOpen(true)">
			<v-icon 
				large
				class="grey--text text--darken-2" 
				>
				expand_less
			</v-icon>
		</v-btn>
		</v-layout>

		<div v-if="buildingCardOpen" class="buildingcard" :style="!$vuetify.breakpoint.smAndDown ? 'right: 30px;' : 'right: 6px;' ">
			
		<v-card >
			<v-card-title 
				primary-title 
				class="cardtop pb-4 pl-5">
				<v-layout align-center >
					<v-flex  class="display-2">{{building.bldgAlpha}}</v-flex>
					<v-flex  class="pl-5 pr-4 headline"> {{building.name}}</v-flex>
					<v-btn 
						icon
						@click="setBuildingCardOpen(false)">
						<v-icon
							large 
							class="grey--text text--darken-2">
							expand_more
						</v-icon>
			  		</v-btn>
				</v-layout>
			</v-card-title>
			<v-layout>
		  	<ElevatorControl />

		  	
			<v-layout column align-center>

				<v-tabs
					grow
				  	slider-color="blue"
				  	style="width: 95%;"
				  	class="mt-2"
				  	v-model="activeTab"
				>
			      <v-tab justify-space-between v-for="item in items" :key="item" ripple class="subheading">
			        {{ item }}
			      </v-tab>
			      <v-tabs-items >
					<v-tab-item>
						<TabBuilding  />
					</v-tab-item>
					<v-tab-item>
						<TabFiles />
					</v-tab-item>  
					<v-tab-item>
						<TabColorize />
					</v-tab-item>  
				</v-tabs-items>
				</v-tabs>
			</v-layout>
			</v-layout>

				<v-card-actions class="mr-2">
					
					<v-layout 
					row align-center style="margin-left: 40px;">
						<v-flex v-if="allowManagerUI" shrink>							
				  			<v-tooltip top>
								<v-btn icon slot="activator" 
									@click="gotoRoomViewer">
									<v-icon :color="darkTheme ? '' : 'grey darken-3'">line_style</v-icon>
								</v-btn>
								<span>Launch RoomViewer</span>
					  		</v-tooltip>
						</v-flex>
						<v-flex v-if="allowManagerUI" shrink>							
				  			<v-tooltip top>
								<v-btn icon slot="activator" 
									
									@click="gotoBldgViewer">
									<v-icon :color="darkTheme ? '' : 'grey darken-3'">apartment</v-icon>
								</v-btn>
								<span>Launch Building Viewer</span>
					  		</v-tooltip>
						</v-flex>
						<v-flex shrink>							
				  			<v-tooltip top>
								<v-btn icon slot="activator" 
									:href="'https://apps.ufs.arizona.edu/buildingmanager/' + building.bldgAlpha" target="_blank">
									<v-icon :color="darkTheme ? '' : 'grey darken-3'">people</v-icon>
								</v-btn>
								<span>Building Managers</span>
					  		</v-tooltip>
						</v-flex>
				  		<v-flex>
				  			<v-btn v-if="!$vuetify.breakpoint.xsOnly" 
				  				style="float: right;"
				  				class="caption" flat color="orange"
					  		 	:to="`/roomtable/${building ? building.bldgAlpha : '0'}`"
					  		 	@click="updateContentSidebar(false)">
					  			Complete Room Table
					  		</v-btn>
					  		
				  		</v-flex>
				  	</v-layout>
				</v-card-actions>
			</v-layout>
			</v-layout>
		  
		</v-card>
		</div>
	</div>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import TabBuilding from './TabBuilding'
import TabFiles from './TabFiles'
import TabColorize from './TabColorize'
import ColorPicker from './ColorPicker'
import ElevatorControl from './ElevatorControl'
import mapFunctions from '../esri-map'

let BuildingCard = {

	data() {
		return {
			tab: null,
			items: ['Info', 'Files', 'Colorize'],
		}
	},
	components: { TabBuilding, TabFiles, TabColorize, ElevatorControl },

	computed: {
		...mapState({
			building: 			state => state.space.selectedBuilding,
			stateActiveTab: 	state => state.ui.activeTab,
			buildingCardOpen: 	state => state.ui.buildingCardOpen,
			colorPickerOpen: 	state => state.ui.colorPickerOpen,
			measureOpen: 		state => state.ui.measureOpen,
			darkTheme: 			state => state.ui.darkTheme,
	  	}),
	  	...mapGetters(['allowManagerUI',]),

	    activeTab: {
            get () {
              return this.stateActiveTab
            },
            set (value) {
                this.setActiveTab(value)
                // 3 = Colorize Tab
                if (value != '2') { this.resetColorize() }  
            }
        }
	},

	methods: {
		...mapMutations(['setSelectedRoom', 'setActiveTab', 'setBuildingCardOpen', 'updateContentSidebar', 'setdvBuildingOnly']),
		...mapActions(['resetColorize', ]),

		gotoRoomViewer() {
			console.log("Launch Roomviewer")
			this.setdvBuildingOnly(this.building)
			this.$router.push({ name: 'RoomViewerToBldg', params: { rvbldg: this.building.bldgAlpha }})
		},
		gotoBldgViewer() {
			console.log("Launch Building viewer")
			this.$router.push({ name: 'bldgviewerToBuilding', params: { dvbldg: this.building.bldgAlpha }})
		},
	}
}

export default BuildingCard

</script>

<style>
.showBCButton {
	position: absolute;

	background-color: rgba(0,0,0,0.3);
	box-shadow: -6px 6px 80px -14px #000;
}

.buildingcard {
	position: absolute;
	top: 100px;

	width: 500px;
	border-width: 3px;
	border-style: solid;
	border-radius: 8px;

	box-shadow: -6px 6px 80px -14px #000;
}

.buildingcard .card {
	border-radius: 5px !important;
}



.colorPicker {
    position: absolute;
    top: 370px;
    right: 369px;
    width: 200px;
    z-index: 1;
}

.cardtop {
	background-color: #222222;
	color: white;
}

.customTab {
/*	height: 530px;
	overflow-y: auto;*/
}
</style>





// WEBPACK FOOTER //
// src/components/buildingcard/BuildingCard.vue